import { waitForElement, waitForObject } from '../../js/utils'

export const fundraisingPages = () => {
  waitForElement('.en__p2p__fundraiser__page').then((fundraisingPage) => {
    //makePrintableFormLink()
    //saveParticipantDetails()
    enParticipantPageLocalStorage()
  })
}

const enParticipantPageLocalStorage = () => {
  waitForObject('enParticipantPage').then((enParticipantPage) => {
    localStorage.setItem('enParticipantPageStored', JSON.stringify(enParticipantPage))
  })
}

const makePrintableFormLink = () => {
  const setButtonTarget = (donateButton) => {
    donateButton.setAttribute('target', '_blank')
    donateButton.classList.add('link-external')
  }

  const createLink = (donateButton) => {
    if (donateButton) {
      const printableFormLink = document.createElement('a')

      printableFormLink.classList.add('link-external', 'link-printable-form')
      printableFormLink.setAttribute('href', 'https://protect.worldwildlife.org/page/64338/action/1')
      printableFormLink.setAttribute('target', '_blank')
      printableFormLink.textContent = 'Or, download this form to mail in a donation.'
      donateButton.insertAdjacentElement('afterend', printableFormLink)
    }
  }

  waitForElement('.en__p2p__fundraiser__donate .en__p2p__button').then((donateButton) => {
    setButtonTarget(donateButton)
    createLink(donateButton)
  })
}

const saveParticipantDetails = () => {
  const saveDetails = (enParticipantPage) => {
    const participantDetails = {
      participantName: enParticipantPage.displayTitle,
      pageId: enParticipantPage.siteId,
      siteName: 'Panda Nation Classroom',
      siteId: enParticipantPage.campaignId,
      supporterId: enParticipantPage.id,
    }

    localStorage.setItem('participant.details', JSON.stringify(participantDetails))
  }

  waitForObject('enParticipantPage').then((enParticipantPage) => {
    console.log('enParticipantPage found')
    saveDetails(enParticipantPage)
  })
}